export default __webpack_public_path__ + "static/media/icon-chat-accept.8ed7e9c9.svg";